export const colors = {
  colors: {
    black: `#18141A`,
    white: `#FFFFFF`,
    primary: {
      red: `#D96C59`,
      blue: `#683061`,
      dark: `#322130`,
      green: `#683061`,
      pink: `#F39200`,
      /** Mauve du logo */
      purple: `#683061`,
      /** Orange du logo */
      orange: `#F39200`,
    },
    brand: {
      mauve: `#683061`,
      orange: `#F39200`,
      charcoal: `#322130`,
      sand: `#F6EFE8`,
      blush: `#C3AEA4`,
      stone: `#BEB196`,
      mist: `#F8F6F3`,
    },
    blue: {
      75: `#F1EBF0`,
      100: `#E4D7E1`,
      200: `#C8AEC5`,
      600: `#8E5C86`,
      700: `#774770`,
      800: `#683061`,
      900: `#4E2449`,
    },
    red: {
      75: `#FFF1EC`,
      100: `#FFE2D3`,
      400: `#F7A16B`,
      500: `#F39200`,
      600: `#D87E00`,
    },
    gray: {
      50: `#FBF8F5`,
      75: `#F6F1EC`,
      100: `#EFE7E0`,
      200: `#E1D5CC`,
      300: `#CDBEB2`,
      400: `#A8988B`,
      500: `#7F7069`,
      600: `#5E514C`,
      700: `#3E3436`,
      800: `#2A2326`,
      900: `#18141A`,
    },
    yellow: {
      100: `hsl(58, 97%, 87%)`,
      200: `hsl(55, 92%, 76%)`,
      300: `hsl(51, 89%, 67%)`,
      400: `hsl(47, 81%, 61%)`,
      500: `hsl(40, 67%, 51%)`,
      800: `hsl(30, 76%, 26%)`,
      900: `hsl(30, 74%, 21%)`,
    },
    orange: {
      100: `#FFE7C1`,
      400: `#F7AD42`,
      500: `#F39200`,
      900: `#7A4300`,
    },
    purple: {
      50: `#F8F0F8`,
      60: `#F4EAF3`,
      75: `#EFE1ED`,
      100: `#E0C9DC`,
      200: `#C39BBC`,
      500: `#8E5C86`,
      600: `#774770`,
      700: `#683061`,
      800: `#56264F`,
      900: `#3D1A39`,
    },
    green: {
      100: `#EFE1ED`,
      200: `#D8C0D3`,
      300: `#B588AD`,
      400: `#8E5C86`,
      500: `#683061`,
      600: `#56264F`,
      800: `#3D1A39`,
      900: `#2E112B`,
    },
    teal: {
      50: `#E6FFFA`,
      75: `hsl(170, 77%, 90%)`,
      100: `hsl(170, 77%, 83%)`,
      200: `hsl(172, 67%, 70%)`,
      300: `#38B2AC`,
      400: `#38B2AC`,
      500: `#319795`,
      600: `hsl(181, 47%, 33%)`,
      700: `hsl(183, 42%, 27%)`,
      800: `hsl(185, 40%, 23%)`,
      900: `hsl(186, 40%, 19%)`,
    },
    pink: {
      75: `#FFF4E4`,
      100: `#FFE6BF`,
      200: `#FFD08A`,
      300: `#F7B55A`,
      400: `#F4A625`,
      500: `#F39200`,
      800: `#AF6200`,
      900: `#7A4300`,
    },
  },
};

export type Colors = typeof colors;
